const getPreviewCookieRepositoryName = (previewCookie) => {
  return (decodeURIComponent(previewCookie).match(/"([^"]+)\.prismic\.io"/) || [])[1];
};
export {
  getPreviewCookieRepositoryName
};
//# sourceMappingURL=getPreviewCookieRepositoryName.js.map
